// //client/src/components/dashboard/DashboardStatsCards.jsx
// import React from "react";

// export default function DashboardStatsCards({
//   stats,
// }) {
//   return (
//     <div className="dashboard-stats-grid">

//       <div className="dashboard-stat-card">
//         <h3>
//           {stats.totalInvoices || 0}
//         </h3>
//         <span>
//           Total Invoices
//         </span>
//       </div>

//       <div className="dashboard-stat-card">
//         <h3>
//           {stats.paidInvoices || 0}
//         </h3>
//         <span>
//           Paid Invoices
//         </span>
//       </div>

//       <div className="dashboard-stat-card">
//         <h3>
//           {stats.pendingInvoices || 0}
//         </h3>
//         <span>
//           Pending Invoices
//         </span>
//       </div>

//     </div>
//   );
// }


// client/src/components/dashboard/DashboardStatsCards.jsx

import React from "react";

const CARDS = [
  {
    key:       "totalInvoices",
    label:     "Total Invoices",
    icon:      "📄",
    iconBg:    "#eff6ff",
    iconColor: "#1d4ed8",
    valueColor:"#111827",
    kicker:    "All records",
  },
  {
    key:       "paidInvoices",
    label:     "Paid Invoices",
    icon:      "✅",
    iconBg:    "#f0fdf4",
    iconColor: "#15803d",
    valueColor:"#15803d",
    kicker:    "Cleared",
  },
  {
    key:       "pendingInvoices",
    label:     "Pending Invoices",
    icon:      "⏳",
    iconBg:    "#fffbeb",
    iconColor: "#b45309",
    valueColor:"#b45309",
    kicker:    "Awaiting payment",
  },
];

export default function DashboardStatsCards({ stats }) {
  const total   = stats.totalInvoices   || 0;
  const paid    = stats.paidInvoices    || 0;
  const pending = stats.pendingInvoices || 0;
  const paidPct = total > 0 ? Math.round((paid / total) * 100) : 0;

  const values = { totalInvoices: total, paidInvoices: paid, pendingInvoices: pending };

  return (
    <div style={styles.grid}>
      {CARDS.map((card) => (
        <div key={card.key} style={styles.card}>

          {/* TOP ROW */}
          <div style={styles.topRow}>
            <div style={{ ...styles.iconWrap, backgroundColor: card.iconBg }}>
              <span style={styles.icon}>{card.icon}</span>
            </div>
            <span style={styles.kicker}>{card.kicker}</span>
          </div>

          {/* VALUE */}
          <div style={{ ...styles.value, color: card.valueColor }}>
            {values[card.key].toLocaleString()}
          </div>

          {/* LABEL */}
          <div style={styles.label}>{card.label}</div>

          {/* PROGRESS BAR — only on total card, shows paid % */}
          {card.key === "totalInvoices" && total > 0 && (
            <div style={styles.progressWrap}>
              <div style={styles.progressTrack}>
                <div style={{ ...styles.progressFill, width: `${paidPct}%` }} />
              </div>
              <span style={styles.progressLabel}>{paidPct}% paid</span>
            </div>
          )}

          {/* RATIO BADGE — paid & pending cards */}
          {card.key === "paidInvoices" && total > 0 && (
            <div style={styles.ratioBadge}>
              <span style={{ ...styles.ratioDot, backgroundColor: "#10b981" }} />
              <span style={styles.ratioText}>{paidPct}% of total</span>
            </div>
          )}
          {card.key === "pendingInvoices" && total > 0 && (
            <div style={styles.ratioBadge}>
              <span style={{ ...styles.ratioDot, backgroundColor: "#f59e0b" }} />
              <span style={styles.ratioText}>{100 - paidPct}% of total</span>
            </div>
          )}

        </div>
      ))}
    </div>
  );
}

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "24px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    padding: "20px 20px 18px",
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    boxSizing: "border-box",
    transition: "box-shadow 0.15s",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  iconWrap: {
    width: "38px", height: "38px",
    borderRadius: "9px",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0,
  },
  icon:   { fontSize: "17px" },
  kicker: {
    fontSize: "10px", fontWeight: "700",
    color: "#9ca3af", letterSpacing: "0.08em",
    textTransform: "uppercase",
  },
  value: {
    fontSize: "32px", fontWeight: "700",
    letterSpacing: "-0.03em", lineHeight: 1,
    color: "#111827",
  },
  label: {
    fontSize: "12px", fontWeight: "600",
    color: "#6b7280", letterSpacing: "0.01em",
  },

  // Progress bar (total card)
  progressWrap:  { display: "flex", alignItems: "center", gap: "8px", marginTop: "2px" },
  progressTrack: { flex: 1, height: "4px", backgroundColor: "#f3f4f6", borderRadius: "999px", overflow: "hidden" },
  progressFill:  { height: "100%", backgroundColor: "#10b981", borderRadius: "999px", transition: "width 0.4s ease" },
  progressLabel: { fontSize: "11px", fontWeight: "600", color: "#9ca3af", whiteSpace: "nowrap" },

  // Ratio badge (paid / pending cards)
  ratioBadge: { display: "flex", alignItems: "center", gap: "6px", marginTop: "2px" },
  ratioDot:   { width: "6px", height: "6px", borderRadius: "50%", flexShrink: 0 },
  ratioText:  { fontSize: "11px", fontWeight: "600", color: "#9ca3af" },
};